module.exports = __webpack_public_path__ + "img/8378a3e.svg";